import type { UserAccess } from '@features/user-access/types';

import Routing from '@core/api/routing';
import { baseApi } from '@core/api/base-api';

export const userAccessApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    userAccess: builder.query<UserAccess, void>({
      query: () => ({
        url: Routing.generate('rest_user_access', {}, true),
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useUserAccessQuery } = userAccessApi;
